import { CommonGetOptions } from "interfaces/dataInterfaces"
import { householdApi } from "./householdApi"

export const organizationsApi = householdApi.injectEndpoints({
  endpoints: builder => ({
    getOrganizations: builder.query<CommonGetOptions[], void>({
      query: () => ({
        url: `Organizations/Get`,
        method: "GET",
      }),
      providesTags: ["Organizations"],
    }),

    addOrganization: builder.mutation<void, { name: string }>({
      query: ({ name }) => ({
        url: `Organizations/Add`,
        method: "POST",
        params: { name },
      }),
      invalidatesTags: ["Organizations"],
    }),

    editOrganization: builder.mutation<void, { id: number; name: string }>({
      query: ({ id, name }) => ({
        url: `Organizations/Put/${id}`,
        method: "PUT",
        params: { name },
      }),
      invalidatesTags: ["Organizations"],
    }),

    deleteOrganization: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `Organizations/Delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Organizations"],
    }),
  }),
})

export const {
  useGetOrganizationsQuery,
  useLazyGetOrganizationsQuery,
  useAddOrganizationMutation,
  useEditOrganizationMutation,
  useDeleteOrganizationMutation,
} = organizationsApi
